import { useCallback } from 'react';
import cyberitySdk from '@cyberity/websdk';
import { useQueryClient } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';

const useCyberityLaunch = ({
  lang,
  containerId,
  getNewAccessToken,
}: {
  lang: string;
  containerId: string;
  getNewAccessToken: () => Promise<string>;
}) => {
  const { session } = useSessionStore();
  const queryClient = useQueryClient();
  const launchWebSdk = useCallback(
    (accessToken: string, applicantEmail: string, applicantPhone: string) => {
      const sdkInstance = cyberitySdk
        .init(accessToken, () => getNewAccessToken())
        .withConf({
          lang,
          email: applicantEmail,
          phone: applicantPhone,
        })
        .on('idCheck.stepCompleted', () => {
          queryClient.invalidateQueries({
            queryKey: ['user-verification-info', session?.userId],
          });
        })
        .on('idCheck.moduleResultPresented', ({ answer }) => {
          console.log('answer', answer);
          queryClient.invalidateQueries({
            queryKey: ['user-verification-info', session?.userId],
          });
        })
        .build();

      sdkInstance.launch(`#${containerId}`);
    },
    [lang, containerId, getNewAccessToken]
  );

  return {
    launchWebSdk,
  };
};

export { useCyberityLaunch };
